"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FilterSelect = void 0;
const react_1 = __importStar(require("react"));
const rc_trigger_1 = __importDefault(require("rc-trigger"));
const components_1 = require("@apitable/components");
const core_1 = require("@apitable/core");
const icons_1 = require("@apitable/icons");
const cell_value_1 = require("../../../ui/cell_value");
const styled_1 = require("./styled");
const getSelectOptions = (value, options) => {
    return (value || []).map(optionId => {
        const option = options.find(option => option.id === optionId);
        if (!option) {
            return null;
        }
        return {
            id: optionId,
            name: option.name,
            color: (0, core_1.getFieldOptionColor)(option.color)
        };
    }).filter(v => Boolean(v));
};
const FilterSelect = (props) => {
    const [visible, setVisible] = (0, react_1.useState)(false);
    const { color } = (0, components_1.useTheme)();
    const { value, field, onChange, operator } = props;
    const isMulti = field.type === core_1.FieldType.MultiSelect || [core_1.FOperator.Contains, core_1.FOperator.DoesNotContain].includes(operator);
    return (react_1.default.createElement(rc_trigger_1.default, { action: ['click'], popup: react_1.default.createElement(OptionList, { isMulti: isMulti, field: field, value: value, onChange: (v) => {
                onChange.length === 0 ? onChange(null) : onChange(v);
            } }), destroyPopupOnHide: true, popupAlign: { points: ['tl', 'bl'], offset: [0, 8] }, popupVisible: visible, onPopupVisibleChange: visible => setVisible(visible), stretch: "width,height" },
        react_1.default.createElement(styled_1.FilterInputWrap, { pointer: true },
            react_1.default.createElement(components_1.Box, { flex: 1, padding: '8px 10px' }, Boolean(value) &&
                react_1.default.createElement(SelectValueBox, { options: field.property.options, selectOptions: getSelectOptions(value, field.property.options) })),
            react_1.default.createElement(components_1.Box, { display: 'flex', alignItems: 'center', paddingRight: '10px' },
                react_1.default.createElement(icons_1.ChevronDownOutlined, { size: 16, color: color.black[300] })))));
};
exports.FilterSelect = FilterSelect;
const SelectValueBox = (props) => {
    const { options, selectOptions } = props;
    return react_1.default.createElement(cell_value_1.CellOptions, { style: { flexWrap: 'inherit' }, options: options || [], selectOptions: selectOptions });
};
const OptionList = (props) => {
    const { field, value, onChange, isMulti } = props;
    const clickOption = (option) => {
        const index = (value || []).findIndex(v => option.id === v);
        let _value = value || [];
        if (index > -1) {
            _value = _value.filter(v => option.id !== v);
        }
        else {
            isMulti ? _value.push(option.id) : _value = [option.id];
        }
        onChange && onChange(_value);
    };
    return (react_1.default.createElement(styled_1.SelectPopupContainer, null,
        react_1.default.createElement("div", null, field.property.options.map(option => (react_1.default.createElement(styled_1.OptionItemWrap, { key: option.id, onClick: () => clickOption(option) },
            react_1.default.createElement(components_1.Box, { flex: '1', width: '100%' },
                react_1.default.createElement(SelectValueBox, { options: field.property.options, selectOptions: getSelectOptions([option.id], field.property.options) })),
            react_1.default.createElement(Check, { isChecked: (value || []).includes(option.id) })))))));
};
const Check = props => {
    const { isChecked } = props;
    const theme = (0, components_1.useTheme)();
    if (isChecked) {
        return react_1.default.createElement(icons_1.CheckOutlined, { size: 16, color: theme.color.deepPurple[500] });
    }
    return react_1.default.createElement(react_1.default.Fragment, null);
};
